var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.779,
    height: 77.201,
    viewBox: "0 0 85.779 77.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account_tree_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "account_tree_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M136.185,293.2V279.8H119.673V235.836H109.7v13.939H80V216h29.7v13.4h26.484V216h29.594v33.776H136.185V235.836H126.106v37.528h10.079V259.426h29.594V293.2ZM86.433,222.433v0Zm56.185,43.426v0Zm0-43.426v0Zm0,20.909h16.727V222.433H142.619Zm0,43.426h16.727V265.859H142.619ZM86.433,243.342h16.834V222.433H86.433Z",
    transform: "translate(-80 -216)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/iconMap.b27382ee5a8d36de481c958df77ec190.svg";
export { ForwardRef as ReactComponent };